:host {
  color: var(--ion-color-primary);
}
